module.exports = __webpack_public_path__ + "img/2.a5734e8a.png";